/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalReauthSubmissionTimingState = {
    Upcoming: 'upcoming',
    NeedsAction: 'needs_action',
    Overdue: 'overdue',
    Completed: 'completed'
} as const;
export type PalReauthSubmissionTimingState = typeof PalReauthSubmissionTimingState[keyof typeof PalReauthSubmissionTimingState];


export function PalReauthSubmissionTimingStateFromJSON(json: any): PalReauthSubmissionTimingState {
    return PalReauthSubmissionTimingStateFromJSONTyped(json, false);
}

export function PalReauthSubmissionTimingStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionTimingState {
    return json as PalReauthSubmissionTimingState;
}

export function PalReauthSubmissionTimingStateToJSON(value?: PalReauthSubmissionTimingState | null): any {
    return value as any;
}

